const capitalize = lower => lower.replace(/^\w/, c => c.toUpperCase())

const stripWhiteSpace = str => str.replace(/^ *([^ ]*) *$/, '$1')

export { capitalize, stripWhiteSpace }
